// components/Card.tsx
import React from 'react';
import { determineTextColor } from '@/lib/utils';

interface ReviewTitleCardProps {
  title: string | null;
  primaryBackgroundColour: string;
  cardStyle: string | null;
}

const getCardStyle = (style: string | null) => {
  switch (style) {
    case 'plain':
      return 'bg-white rounded-xl shadow-md shadow-black/30';
    case 'border':
      return 'bg-white rounded-xl border border-zinc-800';
    case 'shadow':
      return 'bg-white rounded-xl shadow-[5px_5px_0px_2px_#2E2E2E]';
    case 'transparent':
      return 'bg-white bg-opacity-20 rounded-xl shadow';
    default:
      return 'bg-white rounded-xl shadow-md shadow-black/30';
  }
};


const ReviewTitleCard: React.FC<ReviewTitleCardProps> = ({ title, primaryBackgroundColour, cardStyle }) => {
  let textColour = ''
  if (cardStyle === 'transparent' && primaryBackgroundColour) {
    textColour = determineTextColor(primaryBackgroundColour);
  }

  return (
    <div className={`overflow-visible p-4 ${getCardStyle(cardStyle)} italic font-medium bg-card text-card-foreground inline-block m-2`}>
      <h3 style={{ color: textColour }} >&quot;{title}&quot;</h3>
    </div>
  );
};

export default ReviewTitleCard;